import Players from '../Components/Players';

//Page containing the Players component
function PlayersPage(){
    return(
    <div className='page-container'>
        <Players />
    </div>
    )
}

export default PlayersPage;

